import React from 'react';
import { Divider } from './index';

export { Divider } from 'native-base';

export const DividerSoft = (): JSX.Element => (
  <Divider backgroundColor="secondary.alpha.10:alpha.10" />
);
